import React, { memo } from 'react'
import CommonDialog from '../../../common/components/dialog/CommonDialog'
import styles from './PauseProductDialog.module.scss'
import solarProductService from '../../../httpService/SolarProductService'
import { SolarProduct } from '../../../model/solar-product/solar-product'
import { useDispatch } from 'react-redux'
import { showLoader, hideLoader } from '../../../stores/slices/loader-slice'
import { toast } from 'react-toastify'

type Props = {
    product: SolarProduct
    onCloseDialog: () => void
    onProductPaused: () => void
}

const PauseProductDialog: React.FC<Props> = memo((props: Props) => {
    const dispatch = useDispatch();

    const pauseProduct = () => {
        dispatch(showLoader());
        solarProductService.pause(props.product.id!).then(() => {
            props.onProductPaused();
        }).catch(() => {
            toast.error('Failed to pause product');
        }).finally(() => {
            dispatch(hideLoader());
            props.onCloseDialog();
        });
    }

    const cancel = () => {
        props.onCloseDialog();
    }

    return (
        <CommonDialog onCloseDialog={props.onCloseDialog}>
            <div className={styles.container}>
                <div className={styles.title}>
                    Are you sure you want to {
                        props.product.isDeactivated ? 'unpause' : 'pause'
                    } this product?
                </div>
                <div className={styles.description}>
                    {
                        props.product.isDeactivated ? 'Unpausing' : 'Pausing'
                    } a product will make it {
                        props.product.isDeactivated ? 'available' : 'unavailable'
                    } for purchase by customers.
                </div>

                <div className={styles.buttonContainer}>
                    <button className={`standardButton ${styles.button} ${styles.pauseButton}`} onClick={pauseProduct}>{
                        props.product.isDeactivated ? 'Unpause' : 'Pause'
                    }</button>
                    <button className={`standardButton ${styles.button}`} onClick={cancel}>Cancel</button>
                </div>
            </div>
        </CommonDialog>
    )
})

export default PauseProductDialog